// extracted by mini-css-extract-plugin
module.exports =  {"label":"O3n4uC","color-sample":"ZBko4g","colorSample":"ZBko4g","image-swatch":"wpIwOm","imageSwatch":"wpIwOm","disabled":"eTBpzs","input":"dzUD1t"};